import { render, staticRenderFns } from "./RegisterEmisor.vue?vue&type=template&id=04f8199c"
import script from "./RegisterEmisor.vue?vue&type=script&lang=js"
export * from "./RegisterEmisor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04f8199c')) {
      api.createRecord('04f8199c', component.options)
    } else {
      api.reload('04f8199c', component.options)
    }
    module.hot.accept("./RegisterEmisor.vue?vue&type=template&id=04f8199c", function () {
      api.rerender('04f8199c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/components/emisor/RegisterEmisor.vue"
export default component.exports